import { render } from "./TestRouteGuards.vue?vue&type=template&id=1ac1d236&scoped=true"
import script from "./TestRouteGuards.vue?vue&type=script&lang=js"
export * from "./TestRouteGuards.vue?vue&type=script&lang=js"

import "./TestRouteGuards.vue?vue&type=style&index=0&id=1ac1d236&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac1d236"]])

export default __exports__